<template>
  <component :is="icon" v-on="$listeners" />
</template>

<script>
export default {
  name: 'SvgWrapper',
  props: {
    icon: { type: [Object, Function], required: true }
  }
};
</script>
